// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".block-view.card--video{padding:var(--card-padding-video)}.block-view.card--video .light-text{display:flex;align-items:center;justify-content:center}", "",{"version":3,"sources":["webpack://./../../shared/blocks/src/video/view.scss"],"names":[],"mappings":"AAAA,wBACE,iCAAA,CAOA,oCACE,YAAA,CACA,kBAAA,CACA,sBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
